const CARTO_BASEMAP_HOST = 'basemaps.cartocdn.com';

/**
 * Appends the CARTO API key to a raster basemap tile URL.
 *
 * CARTO started requiring a key on `basemaps.cartocdn.com` in August 2026;
 * keyless tiles are still served but stamped with an "API KEY REQUIRED"
 * watermark. Other providers (Google, OSM, ArcGIS, Mapbox) are left untouched —
 * they either need no key or already carry their own token.
 *
 * The URL is treated as a plain string on purpose: parsing it through `URL`
 * would percent-encode the `{z}/{x}/{y}` placeholders Leaflet relies on.
 *
 * @param {string} url tile URL template
 * @returns {string} the template with `key=` appended when applicable
 */
export const withCartoKey = (url) => {
  const key = process.env.CARTO_BASEMAP_KEY;

  if (!key || !url || !url.includes(CARTO_BASEMAP_HOST)) {
    return url;
  }

  if (/[?&]key=/.test(url)) {
    return url;
  }

  const separator = url.includes('?') ? '&' : '?';

  return `${url}${separator}key=${encodeURIComponent(key)}`;
};
